import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    inputWrapper: {
        padding: "1rem 1rem .5rem",
    },
    searchInput: {
        ".mantine-Input-icon": {
            width: "3rem",
        },

        ".mantine-Input-input": {
            border: `1px solid ${theme.colors.gray[2]}`,
            boxShadow: theme.shadows.xs,
            color: theme.colors.gray[9],
            paddingRight: "1rem",

            "&[data-with-icon]": {
                paddingLeft: "3rem",
            },
        },
    },
    searchIcon: {
        color: theme.colors.violet[5],

        "&&": {
            width: "auto",
        },
    },
    regionTypes: {
        backgroundColor: "white",
        borderBottom: `1px solid ${theme.colors.gray[2]}`,
        borderRadius: 0,
        height: "auto",
        overflow: "initial",
        padding: 0,
        width: "100%",

        ".mantine-SegmentedControl-control": {
            flexGrow: "initial",
            padding: ".75rem 1rem 0",

            "&:not(:first-of-type)": {
                border: 0,
            },
        },

        ".mantine-SegmentedControl-label": {
            borderRadius: 0,
            color: theme.colors.gray[7],
            fontSize: ".875rem",
            fontWeight: 400,
            height: "auto",
            lineHeight: 1,
            marginBottom: "-1px",
            padding: "0 0 .75rem",

            "&[data-active]": {
                borderBottom: `2px solid ${theme.colors.violet[5]}`,
                color: theme.colors.gray[9],
            },
        },

        ".mantine-SegmentedControl-indicator": {
            display: "none",
        },
    },
    footer: {
        borderTop: `1px solid ${theme.colors.gray[2]}`,
        display: "flex",
        gap: ".5rem",
        justifyContent: "flex-end",
        padding: ".5rem .75rem .5rem 1rem",
    },
    button: {
        height: "initial",
        padding: ".5rem .75rem",
    },
}))
